import React, { useCallback, useEffect, useRef, useState } from 'react';

export const useSlide = (slideRef: React.RefObject<HTMLDivElement | null>, gap: number) => {
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [showSlideButton, setShowSlideButton] = useState({ left: false, right: false });

  const handlePrevSlide = useCallback(() => {
    slideRef?.current?.scrollTo({
      left: slideRef.current.scrollLeft - slideRef.current.clientWidth - gap,
      behavior: 'smooth',
    });
  }, [gap, slideRef]);

  const handleNextSlide = useCallback(() => {
    slideRef?.current?.scrollTo({
      left: slideRef.current.scrollLeft + slideRef.current.clientWidth + gap,
      behavior: 'smooth',
    });
  }, [gap, slideRef]);

  const handleSlide = useCallback(() => {
    if (debounceRef?.current) {
      clearTimeout(debounceRef.current);
    }

    if (debounceRef) {
      debounceRef.current = setTimeout(() => {
        if (slideRef?.current) {
          setShowSlideButton({
            left: slideRef.current.scrollLeft !== 0,
            right:
              Math.round(slideRef.current.scrollLeft + slideRef.current.clientWidth) < slideRef.current.scrollWidth,
          });
        }
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideRef?.current]);

  useEffect(() => {
    handleSlide();
  }, [handleSlide]);

  return { handlePrevSlide, handleNextSlide, handleSlide, showSlideButton };
};
